import React from 'react'
import { useLocation } from 'react-router-dom'

import queryString from 'query-string'

import { Formik } from 'formik'
import Yup from '_zari/validation/_yup'

import { Button, Form, Row, Col } from '_zari/core'

import { OrigenesContabilidadConstant, CondicionesPagoConstant } from 'constants/index'

import * as FormGroups from './formGroups'

const ValidationSchema = Yup.object().shape({
  condicionPago: Yup.string().required(),
  glosa: Yup.string().notRequired(),
  fechaPago: Yup.string().when('condicionPago', {
    is: CondicionesPagoConstant.CONTADO,
    then: Yup.string().required()
  }),
  monedaPago: Yup.string().when('condicionPago', {
    is: CondicionesPagoConstant.CONTADO,
    then: Yup.string().required()
  }),
  cuentaContablePago: Yup.string().when('condicionPago', {
    is: CondicionesPagoConstant.CONTADO,
    then: Yup.string().required()
  }),
  importePago: Yup.number().when('condicionPago', {
    is: CondicionesPagoConstant.CONTADO,
    then: Yup.number().required().min(1)
  }),
  medioDePago: Yup.string().when('condicionPago', {
    is: CondicionesPagoConstant.CONTADO,
    then: Yup.string().required()
  }),
  tipoCambio: Yup.number().when('condicionPago', {
    is: CondicionesPagoConstant.CONTADO,
    then: Yup.number().required().min(1)
  }),
  flujoEfectivo: Yup.string().when('condicionPago', {
    is: CondicionesPagoConstant.CONTADO,
    then: Yup.string().required()
  })
})

const FormularioPagos = ({ submitFunction, formikPagoRef }) => {
  const location = useLocation()

  const formInitialValues = React.useMemo(() => {
    const condicionPago = CondicionesPagoConstant.CONTADO

    let { origen } = queryString.parse(location.search)

    return {
      condicionPago: condicionPago,
      fechaPago: '',
      monedaBase: 'SOLES',
      monedaPago: 'SOLES',
      cuentaContablePago: '',
      importeBase: '',
      importePago: '',
      glosa: '',
      medioDePago: '008',
      numeroDocumentoPago: '',
      tipoCambio: 1,
      flujoEfectivo: origen === OrigenesContabilidadConstant.COBRANZAS ? 'O001' : 'O050'
    }
  }, [location.search])

  const submitHandler = (data, { setSubmitting }) => {
    submitFunction(data, { setSubmitting })
  }

  return (
    <Formik initialValues={formInitialValues} onSubmit={submitHandler} validationSchema={ValidationSchema} innerRef={formikPagoRef}>
      {({ errors, handleSubmit, isSubmitting, touched, values, setFieldValue }) => (
        <Form>
          <FormGroups.FechaPagoFormGroup fIsSubmitting={isSubmitting} iError={errors.fechaPago} iTouched={touched.fechaPago} />
          <FormGroups.PlantillaCobranzaFormGroup
            fIsSubmitting={isSubmitting}
            iError={errors.cuentaContablePago}
            iTouched={touched.cuentaContablePago}
            setFieldValue={setFieldValue}
          />
          <FormGroups.ImportePagoFormGroup
            vMoneda={values.monedaBase}
            vImporteBase={values.importeBase}
            vMonedaPago={values.monedaPago}
            vTipoCambio={values.tipoCambio}
            iValue={values.importePago}
            setFieldValue={setFieldValue}
          />
          <FormGroups.MedioDePagoFormGroup fIsSubmitting={isSubmitting} iError={errors.medioDePago} iTouched={touched.medioDePago} />
          <FormGroups.NumeroDocumentoPagoFormGroup
            fIsSubmitting={isSubmitting}
            iError={errors.numeroDocumentoPago}
            iTouched={touched.numeroDocumentoPago}
          />
          {values.monedaPago !== values.monedaBase && (
            <FormGroups.TipoCambioFormGroup
              iFechaPagoValue={values.fechaPago}
              vMoneda={values.monedaBase}
              iMonedaPagoValue={values.monedaPago}
              setFieldValue={setFieldValue}
              fIsSubmitting={isSubmitting}
              iError={errors.tipoCambio}
              iTouched={touched.tipoCambio}
            />
          )}
          <FormGroups.FlujoEfectivoFormGroup fIsSubmitting={isSubmitting} iError={errors.flujoEfectivo} iTouched={touched.flujoEfectivo} />
          <FormGroups.GlosaFormGroup fIsSubmitting={isSubmitting} iError={errors.glosa} iTouched={touched.glosa} />
          <Row>
            <Col md={12} className='text-right'>
              <Button color='secondary'>Cancelar</Button>
              <Button id='button-formulariopagos-procesar' onClick={handleSubmit} disabled={isSubmitting}>
                Procesar
              </Button>
            </Col>
          </Row>
        </Form>
      )}
    </Formik>
  )
}
export default FormularioPagos
